/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum TabMyChartAllergiesAliases {
  ALLERGIES_CARD_CONTAINER = 'allergies-card-container',
  ALLERGIES_CARD_CONTAINER_BODY = 'allergies-card-container-body',
  ALLERGIES_CARD_ZONE_ALERGIES = 'allergies-card-zone-alergies',
  ALLERGIES_CARD_ZONE_END_DATE = 'allergies-card-zone-end-date',
  ALLERGIES_CARD_ZONE_START_DATE = 'allergies-card-zone-start-date',
  ALLERGIES_CARD_ZONE_STATUS = 'allergies-card-zone-status',
  AUTOCOMPLETE_STATUS = 'autocomplete-status',
  DECK_ALLERGIES = 'deck-allergies',
  FETCH_MY_CHART_ALLERGIES = 'fetch-my-chart-allergies',
  FIELD_ALLERGIE = 'field-allergie',
  FIELD_END_DATE = 'field-end-date',
  FIELD_FROM_FILTER = 'field-from-filter',
  FIELD_START_DATE = 'field-start-date',
  FIELD_STATUS = 'field-status',
  FIELD_STATUS_LIST = 'field-status-list',
  FIELD_UNTIL_FILTER = 'field-until-filter',
  FILTER_ALLERGIES = 'filter-allergies',
  FROM_DATE_FIELD = 'from-date-field',
  LAYOUT_TAB_ALLERGIES = 'layout-tab-allergies',
  MAPPER_CARD = 'mapper-card',
  MAPPER_STATUS = 'mapper-status',
  TEXT_ALLERGIE = 'text-allergie',
  TEXT_END_DATE = 'text-end-date',
  TEXT_START_DATE = 'text-start-date',
  TEXT_STATUS = 'text-status',
  TEXT_STATUS_LIST = 'text-status-list',
  UNTIL_DATE_FIELD = 'until-date-field',
}
export { TabMyChartAllergiesAliases };
